log = require 'loglevel'
window.__log = log
log.disableAll()

# Config
configDefaults = require 'configDefaults'
errorConfig = require 'errors'

# Extenders
arrayExtender = require 'arrayExtender'
pixiExtender = require 'pixiExtender'

# Managers
canvasManager     = require 'canvasManager'
currencyManager   = require 'currencyManager'
eventManager      = require 'eventManager'
fontManager       = require 'fontManager'
imageManager      = require 'imageManager'
loadingManager    = require 'loadingManager'
localeManager     = require 'localeManager'
networkManager    = require 'networkManager'
soundManager      = require 'soundManager'
realityManager    = require 'realityManager'
trackingManager   = require 'trackingManager'

# Views
GameView          = require 'gameView'
MenuView          = require 'menuView'
# SettingsView      = require 'settingsView'
HelpView          = require 'helpView'
NotificationView  = require 'notificationView'
BottomBarView     = require 'bottomBarView'
# TopBarView        = require 'topBarView'

# Models
gameModel         = require 'gameModel'
imageModel        = require 'imageModel'

#-----------------------------

class Game

  name: "Game"
  parallaxOffset: 150

  # -------------------------------------------
  #
  # Construct
  #
  constructor: ->

    # inject the common & default config options
    gameModel.inject(configDefaults)

    # log the start
    log.info @name, 'constructor'

    # start the progress bar
    loadingManager.start '#progress-bar'

    # pariplay = require 'pariplay'
    #

    # get the correct RGS integration

    if true
      that = @
      require.ensure ['pariplay'], (require) ->
        RGS = require('pariplay').Pariplay
        that.loadGame(RGS)
      , 'pp'

    else
      that = @
      require.ensure ['gluckgames'], (require) ->
        RGS = require('gluckgames').GluckGames
        that.loadGame(RGS)
      , 'gg'

  #----------------------------
  #
  # Get data from the query string and make the loadGame call
  #
  loadGame: (RGS) ->

    # get the query string
    queryData = UTIL.getQueryAsObj()

    # overwrite games which dont have a code
    if __theme.apiGameCode
      queryData.gameCode = __theme.apiGameCode

    # create an instance of the RGS lib &
    # set it up with the URL querystring data
    @rgs = new RGS(queryData, __isMobile)

    # toggle logging based on the gameModel.debug
    @setupLogging()

    @rgs.loadGame (err, rgsModel, code) =>
      @loadGameHandler(err, rgsModel)

  #----------------------------
  #
  # Handle the response of the loadGame call
  #
  loadGameHandler: (err, rgsModel) ->
    log.info @name, 'loadGameHandler', rgsModel, err

    # inject the data from the load game request
    gameModel.inject rgsModel.getData()

    # inject the theme specific values
    gameModel.inject(__theme)

    # make the whole thing global, for easy logging
    window.__config = gameModel

    # setup the currency manager
    @setupCurrencyManager()

    # setup all the event listeners
    @setupEventListeners()

    # toggle showing the debug info & options
    @setupDebugging()

    # start Google Analytics tracking
    @setupTrackingManager()

    # load assets, fonts, images, & translations
    @setupFontManager (result) =>
      @setupImageManager (resources) =>
        @setupLocaleManager (defaultLang, localeErr) =>

          # this essentially starts PIXI
          # and the render loop
          @setupCanvasManager =>

            # setup some views, so we can either
            # display the game or any errors
            @setupInitialViews =>

              # show the game and hide the loader
              @showGameAfterDelay()

              # wait until we get a valid response
              # this callback will be called multiple times
              if err?
                @showError(err)
                return

              # start the background / sound fx
              @setupSoundManager()

              # now we validate the state of the game
              # we wait until now so everything is setup
              # and any actions such as errors or replays
              # can be displayed to the user
              @rgs.getInitialBalance rgsModel, (err, balance, code) =>

                # wait until we get a valid response
                # this callback will be called multiple times
                if err?
                  @showError(err)
                  return

                # if the balance is unknown. `-1` represents unknown
                balance = -1 unless balance?

                # tell the rest of the app about the balance
                eventManager.trigger 'balance', {balance: balance, animate: false}

                # update the balance if the process got a new balance
                gameModel.setBalance balance if balance?

                # tell Google Analytics we are up and running
                trackingManager.trackEvent 'Request', 'LoadGame', !err?

                # set the default reality check timer
                @setupRealityCheckManager()

                # start a replay game first if there is one to show
                return @showReplayMessage() if gameModel.getReplayOutcome()?

                # start a normal game (no replay)
                @startGame()

    return

  #----------------------------------------------
  #
  # Add all the internal event listeners
  #
  setupEventListeners: ->

    # document/window events
    eventManager.listenTo 'page-resize', (data) => @sizeToFit(data)
    eventManager.listenTo 'page-hide', (data) => @pauseGame(data)
    eventManager.listenTo 'page-show', (data) => @resumeGame(data)

    # bet events
    eventManager.listenTo 'place-bet', (data) => @placeBet(data)
    eventManager.listenTo 'end-round', (data) => @endRound(data)

    # page navigation events
    eventManager.listenTo 'show-menu', (data) => @showMenuView(data)
    eventManager.listenTo 'show-help', (data) => @showHelpView(data)
    eventManager.listenTo 'show-settings', (data) => @showSettingsView(data)
    eventManager.listenTo 'start-replay', (data) => @startReplay(data)
    eventManager.listenTo 'end-replay', (data) => @endReplay(data)

    # canvasManager (navigation) events
    eventManager.listenTo 'reload', (e) => @reload(e)
    eventManager.listenTo 'root-view', (data) => @rootViewShown(data)
    eventManager.listenTo 'pop-overlay', (data) => @popOverlay(data)

    # realityCheck events
    eventManager.listenTo 'hide-reality-check', (data) => @hideRealityCheck(data)
    eventManager.listenTo 'change-reality-check', (value) => @realityCheckChanged(value)

    # error Events
    eventManager.listenTo 'show-error', (err) => @showError(err)
    eventManager.listenTo 'hide-error', (err) => @hideError(err)
    eventManager.listenTo 'showing-error', (data) => @disableUserActions(data)
    eventManager.listenTo 'hiding-error', (data) => @enableUserActions(data)

    # RGS external links
    eventManager.listenTo 'home', (e) => @rgs.goHome()
    eventManager.listenTo 'cashier', (e) => @rgs.goCashier()
    eventManager.listenTo 'buy-more', (e) => @rgs.goBuyMore()
    eventManager.listenTo 'history', (e) => @rgs.goHistory()

    # misc events
    eventManager.listenTo 'mute', (state) => @toggleMute(state)
    eventManager.listenTo 'balance', (amount) => @balanceChanged(amount)
    eventManager.listenTo 'no-tickets-left', (data) => @noTicketsLeft(data)
    eventManager.listenTo 'will-reveal-all', (data) => @willRevealAll(data)
    eventManager.listenTo 'track-event', (data) => @trackEvent(data)

    # result
    eventManager.listenTo 'won', (amount) => @won(amount)

  #----------------------------------------------
  #
  # Should we be console.logging
  #

  setupLogging: ->
    # turn loggin of by default
    if gameModel.debug
      log.enableAll()

  #----------------------------------------------
  #
  # Setup the views we will need on launch
  #
  setupInitialViews: (cb) ->
    log.info @name, 'setupInitialViews'

    # set up this shit
    @menuView = new MenuView()
    @menuView.setup()

    # setup menu view
    @showMenuView()

    # make everything fit
    @sizeToFit()

    # setup game view aswell
    @gameView = new GameView()
    @gameView.initSetup(cb)

    # setup this shit helpView
    if gameModel.getHelpUrl()?
      @helpView = new HelpView() unless @helpView?

    # setup once
    # @gameView.win = (amount, ticketId, prizeId, isReplay, hasNoTickets) =>
    #   @showResultView amount, ticketId, prizeId, isReplay, hasNoTickets

  # -------------------------------------------
  #
  # Setup the class that managers PIXI and all the view navigation
  #
  setupCanvasManager: (cb) ->
    # build the views needed for the canvas manager
    @gameBg = new PIXI.Sprite.fromImage(imageModel.backgroundImage)
    @bottomBarView = new BottomBarView(gameModel.rendererWidth,gameModel.rendererHeight)

    canvasManager.setup @gameBg, @bottomBarView, @parallaxOffset
    canvasManager.renderCanvas()
    canvasManager.sizeToFit()
    canvasManager.pushInitHistory 'MenuView'
    canvasManager.enableScrolling()

    # upload images to the GPU we need the PIXI renderer to do this
    ss = imageManager.getSpriteSheetImageNames()
    canvasManager.uploadImagesToGPU ss

    if gameModel.hasBackgroundView
      parallax = @parallaxOffset
      require.ensure ["../view/themes/mapping"], (require) ->
        BackgroundView = require "../view/themes/mapping"
        backgroundView = new BackgroundView()
        canvasManager.addBackgroundView backgroundView, cb
      , 'background'

    else
      cb()


  # -------------------------------------------
  #
  # Preload some of the images
  #
  setupImageManager: (cb) ->
    urls = imageModel.setup()
    imageManager.loadAssets urls, cb

  # -------------------------------------------
  #
  # Load the correct locale/language files
  #
  setupLocaleManager: (cb) ->
    lang = gameModel.getLanguageCode()
    localeManager.defaultLanguage = gameModel.defaultLanguage
    localeManager.setLanguage lang, cb

  # -------------------------------------------
  #
  # Setup the correct currency formatting
  #
  setupCurrencyManager: ->
    options =
      cc: gameModel.getCurrencyCode()
      lc: gameModel.getLanguageCode()
    currencyManager.setup(options)

    if @rgs.currencyLoaded
      @rgs.currencyLoaded
        cs:currencyManager.getCurrencySymbol()
        cc:gameModel.getCurrencyCode()

  # -------------------------------------------
  #
  # Load the fonts for the theme
  #
  setupFontManager: (cb) ->
    # copy all the fonts over
    fake = ->
      require "../../themes/#{__themeCode}/font/#{val}.eot"
      require "../../themes/#{__themeCode}/font/#{val}.svg"
      require "../../themes/#{__themeCode}/font/#{val}.ttf"
      require "../../themes/#{__themeCode}/font/#{val}.woff"
      require "../../themes/#{__themeCode}/font/#{val}.woff2"

    # the css file loads those fonts
    fontCssUrl = require "../../themes/#{__themeCode}/fonts.css"
    fontsToLoad = [gameModel.getFontWithVariations(), gameModel.getSecondaryFont()]
    fontManager.loadFonts fontsToLoad, fontCssUrl, cb

  # -------------------------------------------
  #
  # Start up the audio
  #
  setupSoundManager: ->

    # Handler function to start WebAudio on user interaction
    startAudio = ->

      # remove listener after first touch
      document.getElementById("canvas").removeEventListener 'touchend', startAudio, false

      # start the audio
      soundManager.startAudio()


    # get url of JSON sprite sheet
    audioSpriteUrl = require "../../themes/#{__themeCode}/sound/audio-sprite.json"

    # fetch the JSON sprite sheet
    networkManager.getJSON audioSpriteUrl, (audioSpriteObj, err, code) =>

      # catch error
      return if err? or not audioSpriteObj?

      # make background audio loop
      audioSpriteObj.sprite['music'].push true

      # get audio urls
      mp3 = require "../../themes/#{__themeCode}/sound/audio-sprite.mp3"
      ogg = require "../../themes/#{__themeCode}/sound/audio-sprite.ogg"

      # build options
      options =
        mp3: mp3 + "?v=" + __version # version audio files
        ogg: ogg + "?v=" + __version # version audio files
        masterVolume: gameModel.getSound()
        volumes: gameModel.sounds.volumes
        mute: gameModel.getInitialMute()
        audioSpriteObj: audioSpriteObj

      # Load the audio sprite json and setup for playback
      soundManager.setup options

      # if we are NOT on a touch device, placeback straight away
      return startAudio() if not __isTouch

      # set everything to mute
      @mute()

      # add a touch listener in order to start the audio from user interaction
      document.getElementById("canvas").addEventListener 'touchend', startAudio, false

  # -------------------------------------------
  #
  # Start Google Analytics event and error tracking
  #
  setupTrackingManager: ->
    trackingManager.setup(gameModel.gameCode)

  # -------------------------------------------
  #
  # Show the debug options
  #
  setupDebugging: ->

    if gameModel.getDebug()
      require.ensure ['debugManager'], (require) ->
        debugManager = require 'debugManager'
        prizeCount = Object.keys(gameModel.images.prizes).length;
        debugManager.render(prizeCount)
      , 'debug-manager'

  # -------------------------------------------

  setupRealityCheckManager: ->
    # set a default reality check interval
    gameModel.setDefaultRealityInterval()

    if gameModel.shouldShowRealityCheck()

      trackingManager.trackEvent 'RealityCheck', 'event', 'show'

      eventManager.listenTo "reality", (msg, e) =>
        @showRealityCheck msg

  # -------------------------------------------
  #
  # Hide the load screen and display the game after short delay
  #
  showGameAfterDelay: ->
    setTimeout( =>
      loadingManager.hideInitialLoader()
      canvasManager.showCanvasEle()
    , gameModel.hideLoaderDelay)

  #----------------------------------------------
  #
  # Beginning of game play. After any loading messages or replays
  #
  startGame: ->
    # start normal game
    @enableUserActions()
    canvasManager.popOverlay()

    @rgs.balanceHandler = (balance) ->
      eventManager.trigger 'balance', balance

    eventManager.trigger 'balance', gameModel.getBalance()

    if gameModel.isOutOfTickets() and gameModel.shouldShowBuyMorePopup()
      @showError {code:'NO_TICKETS_LEFT'}
      return

  # -------------------------------------------

  placeBet: ->

    if gameModel.shouldShowRealityCheck()
      realityManager.canShowRealityCheck false

    @startRound gameModel.getStake()

  # -------------------------------------------

  startRound: (stake) ->

    if gameModel.isOutOfTickets()
      @noTicketsLeft()

    if gameModel.isOutOfTickets() and gameModel.shouldShowBuyMorePopup()
      @showError {code:'NO_TICKETS_LEFT'}
      return

    @showGameView()

    @rgs.placeBet stake, (err, betModel, code) =>

      if err?
        @showError(err)
        return

      canvasManager.popAllOverlays()

      if gameModel.shouldShowRealityCheck()
        realityManager.start(gameModel.getRealityIntervalInMs())

      @gameView.executeBet(betModel, err, code)

      canvasManager.disableScrolling()

  # -------------------------------------------

  endRound: (data) ->
    @rgs.endBet(data)

  # -------------------------------------------

  showReplayMessage: ->
    @showError {code:'REPLAY_START'}

  # -------------------------------------------

  startReplay: ->

    ticketModel = gameModel.getReplayOutcome()
    @rgs.replayBet ticketModel, (err, betModel, code) =>

      if err?
        @showError(err)
        return

      trackingManager.trackEvent 'Replay', 'event', 'start'
      eventManager.trigger 'balance', betModel.getBalanceBefore()

      @gameView.setupWithTicket betModel, =>
        @showGameView(true)
        @enableUserActions()
      , true

  # -------------------------------------------

  endReplay: ->
    eventManager.trigger 'enable-navigation'
    eventManager.trigger 'balance', {balance: gameModel.getBalance(), animate: false}
    @showMenuView()
    @startGame()

  # -------------------------------------------

  showGameView: (isReplay) ->

    trackingManager.trackEvent 'GameView', 'views', 'show'

    supressEvents = isReplay
    canvasManager.popAllOverlays(supressEvents)
    canvasManager.popAllViews()

    @gameView.showStart() unless isReplay

    @pushView @gameView

  # -------------------------------------------

  showMenuView: ->

    trackingManager.trackEvent 'MenuView', 'views', 'show'

    @menuView = new MenuView() unless @menuView?

    canvasManager.popOverlay()
    canvasManager.popAllViews()

    @pushView @menuView

  # -------------------------------------------

  showSettingsView: ->
    trackingManager.trackEvent 'SettingsView', 'views', 'show'
    @settingsView = new SettingsView() unless @settingsView?
    @pushView @settingsView

  # -------------------------------------------

  showHelpView: ->
    return unless gameModel.getHelpUrl()?
    return if canvasManager.isTransitioning

    if @helpView.isShowing
      canvasManager.back()
      return

    @gameView.skipResultAnimation()

    trackingManager.trackEvent 'HelpView', 'views', 'show'
    @pushView @helpView

  # -------------------------------------------

  showError: (rawErr) ->

    code = rawErr.code if rawErr.code?
    serverMsg = rawErr.msg if rawErr.msg?

    log.info @constructor.name, 'show' , code

    err = UTIL.clone errorConfig[code]
    return unless err?

    if err.showServerMsg? and err.showServerMsg
      err.msg = serverMsg if serverMsg?

    if err.buttons?
      for button in err.buttons
        button.text = __t.str(button.textKey)
    else
      err.buttons = []

    if err.fatal
      console.error 'fatal'
      @disableUserActions()

    trackingManager.trackException code+':'+serverMsg, err.fatal

    @notificationView = new NotificationView() unless @notificationView?
    @notificationView.setup err.title, err.msg, err.buttons

    @pushOverlay @notificationView

  # -------------------------------------------

  hideError: ->
    @gameView.resetAfterNotification()
    canvasManager.popOverlay()

  # -------------------------------------------

  showRealityCheck: (msg) ->

    @disableUserActions()

    if @isShowingRealityCheck
      @notificationView.updateMsg msg
      return

    err = UTIL.clone errorConfig['REALITY_CHECK']

    @notificationView = new NotificationView() unless @notificationView?

    @notificationView.setup err.title, msg, err.buttons
    @pushOverlay @notificationView
    @isShowingRealityCheck = true

    trackingManager.trackEvent 'RealityView', 'views', 'show'

  # -------------------------------------------

  hideRealityCheck: ->
    @isShowingRealityCheck = false
    canvasManager.popOverlay()
    @enableUserActions()
    @gameView.resetAfterNotification()

  #----------------------------------------------

  realityCheckChanged: (value) ->
    if gameModel.shouldShowRealityCheck()
      gameModel.setRealityInterval(value)
      realityManager.setCheckIntveral(gameModel.getRealityIntervalInMs())

  #----------------------------------------------

  sizeToFit: ->

    canvasManager.sizeToFit()

    @menuView.resize() if @menuView?
    @gameView.resize() if @gameView?
    @helpView.resize() if @helpView?
    @settingsView.resize() if @settingsView?
    @notificationView.resize() if @notificationView?

    w = document.getElementById("canvas").style.width
    h = document.getElementById("canvas").style.height
    return if w is @lastW and h is @lastH
    @lastW = w
    @lastH = h

    @rgs.resize(w,h)

  #----------------------------------------------

  reload: ->
    location.reload()

  #----------------------------------------------

  pushView: (view) ->

    canvasManager.pushView view

  # -------------------------------------------

  pushOverlay: (view) ->

    canvasManager.pushOverlay view

  # -------------------------------------------

  popOverlay: ->

    canvasManager.popOverlay()

  # -------------------------------------------

  rootViewShown: ->
    @showingHelpView = false

  # -------------------------------------------

  won: (amount) ->
    # @bottomBarView.showLastWin(amount)

  # -------------------------------------------

  resumeGame: ->
    canvasManager.freezeGame = false
    soundManager.resumeAll()

  #----------------------------------------------

  pauseGame: ->
    canvasManager.freezeGame = true
    soundManager.pauseAll()

  # -------------------------------------------

  toggleMute: ->
    log.info 'toggle mute'
    if !gameModel.getMute()
      @mute()
    else
      @unMute()

  # -------------------------------------------

  mute: ->
    gameModel.setMute true
    soundManager.setMute true
    @bottomBarView.displaySoundOffButton()
    trackingManager.trackEvent 'Mute', 'button', true

  # -------------------------------------------

  unMute: ->
    gameModel.setMute false
    soundManager.setMute false
    @bottomBarView.displaySoundOnButton()
    trackingManager.trackEvent 'Mute', 'button', false

  # -------------------------------------------

  balanceChanged: (amount) ->
    return if amount is gameModel.getBalance()
    @rgs.balanceChanged(amount)

  #----------------------------------------------

  noTicketsLeft: ->
    @rgs.noTicketsLeft()

  #----------------------------------------------

  willRevealAll: ->
    @rgs.willRevealAll()

  #----------------------------------------------

  enableUserActions: ->
    canvasManager.enableUserActions()

  # -------------------------------------------

  disableUserActions: ->
    canvasManager.disableUserActions()

  # -------------------------------------------

  trackEvent: (data) ->
    trackingManager.trackEvent data[0], data[1], data[2]

  # -------------------------------------------

module.exports = new Game()




// WEBPACK FOOTER //
// ./coffee/app/game.coffee